import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";

const images = [
  "./img/sladky-bar/sladky-bar-1.jpg",
  "./img/sladky-bar/sladky-bar-2.jpg",
  "./img/sladky-bar/sladky-bar-3.jpg",
  "./img/sladky-bar/sladky-bar-4.jpg",
  "./img/sladky-bar/sladky-bar-5.jpg",
  "./img/sladky-bar/sladky-bar-6.jpg",
  "./img/sladky-bar/sladky-bar-7.jpg",
  "./img/sladky-bar/sladky-bar-8.jpg",
  "./img/sladky-bar/sladky-bar-9.jpg",
  "./img/sladky-bar/sladky-bar-10.jpg",
  "./img/sladky-bar/sladky-bar-11.jpg",
  "./img/sladky-bar/sladky-bar-12.jpg",
  "./img/sladky-bar/sladky-bar-13.jpg",
  "./img/sladky-bar/sladky-bar-14.jpg",
  "./img/sladky-bar/sladky-bar-15.jpg",
  "./img/sladky-bar/sladky-bar-16.jpg",
  "./img/sladky-bar/sladky-bar-17.jpg",
  "./img/sladky-bar/sladky-bar-18.jpg",
  "./img/sladky-bar/sladky-bar-19.jpg",
  "./img/sladky-bar/sladky-bar-20.jpg",
  "./img/sladky-bar/sladky-bar-21.jpg",
  "./img/sladky-bar/sladky-bar-22.jpg",
];

const FotogalerieSladkyBar: React.FC = () => {
  return (
    <>
      {/* ================= HEAD ================= */}
      <Helmet>
        <title>Sladký bar | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Fotogalerie sladkého baru v Hospůdce pod Rablinů – dorty, zákusky a sladké rauty na svatby i oslavy."
        />
      </Helmet>

      {/* ================= NAVBAR (IZOLOVANÝ) ================= */}
      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      {/* ================= OBSAH ================= */}
      <main className="bg-[#F5E7CC] text-[#32180d] overflow-x-hidden">

        {/* ================= NADPIS ================= */}
        <section className="bg-white py-20 text-center">
          <h1 className="text-3xl md:text-4xl font-bold font-serif">
            SLADKÝ BAR
          </h1>
        </section>

        {/* ================= GALERIE ================= */}
        <section className="max-w-7xl mx-auto px-6 py-20">
          <div
            className="
              grid
              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-3
              gap-6
            "
          >
            {images.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`Sladký bar ${i + 1}`}
                loading="lazy"
                className="
                  w-full
                  h-64
                  object-cover
                  rounded-xl
                  shadow-md
                  hover:scale-[1.02]
                  transition-transform
                  duration-300
                "
              />
            ))}
          </div>
        </section>

        {/* ================= FOOTER (ABSOLUTNÍ RESET) ================= */}
        <div className="[all:unset] block">
          <Footer />
        </div>

      </main>
    </>
  );
};

export default FotogalerieSladkyBar;
